import React from "react";
import classNames from "classnames";

const Main = ({ className, scrollContainer, children }) => (
  <div className={classNames("main", className)} ref={scrollContainer}>{children}</div>
);

export default Main;
